var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.boleto.funding_instrument
    ? _c("section", [
        _c("p", { staticClass: "mb-10" }, [
          _vm._v("Baixe o boleto ou copie a linha digitável:")
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: _vm.boleto.funding_instrument.url_print,
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._m(0)]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "boleto-info" }, [
          _c("div", { staticClass: "line-code" }, [
            _c("b", { attrs: { id: "line_code" } }, [
              _vm._v(_vm._s(_vm.boleto.funding_instrument.line_code))
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "copy-button",
                on: { click: _vm.copyToClipBoard }
              },
              [_vm._v("copiar")]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn bg-pink-outline" }, [
      _vm._v("\n      Baixar boleto\n      "),
      _c("img", {
        staticClass: "ml-10",
        attrs: { src: "/static/download.svg", height: "15px" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c33eeec2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c33eeec2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Boleto.vue
// module id = null
// module chunks = 